import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';
import Box from '@mui/material/Box';

// project imports
import Logo from './LogoMain';
import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH } from 'config';
import { getLandingPathForUser, getStoredUser } from 'utils/accessControl';

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection({ reverse, sx, to }) {
  const landingPath = getLandingPathForUser(getStoredUser());

  return (
    <ButtonBase disableRipple component={Link} to={to || landingPath || APP_DEFAULT_PATH} sx={sx} aria-label="Logo">
      <Box className="logo-icon" sx={{ display: 'flex', width: 35, height: 35, alignItems: 'center', justifyContent: 'center', mr: 1.25 }}>
        <Box sx={{ width: 30, height: 30, '& svg': { width: '100%', height: '100%' } }}>
          <LogoIcon />
        </Box>
      </Box>
      <Box className="logo-main" sx={{ display: 'flex', alignItems: 'center' }}>
        <Logo reverse={reverse} />
      </Box>
    </ButtonBase>
  );
}

LogoSection.propTypes = { reverse: PropTypes.bool, sx: PropTypes.any, to: PropTypes.any };
